import { render, staticRenderFns } from "./LampVe2V1ControllerTelemetryCard.vue?vue&type=template&id=d970f1c8&scoped=true&"
import script from "./LampVe2V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
export * from "./LampVe2V1ControllerTelemetryCard.vue?vue&type=script&lang=ts&"
import style0 from "./LampVe2V1ControllerTelemetryCard.vue?vue&type=style&index=0&id=d970f1c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d970f1c8",
  null
  
)

export default component.exports